export default __webpack_public_path__ + "static/media/icon-download.686e55ab.svg";